import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'FRONTEND-CDMS';

  // public Timeout: any;

  // public ColorConfirm: string = '#20a8e1';
  // public ColorsCancel: string = '#fc6161';

  // constructor(private router: Router) { }

  // @HostListener('document:mousemove', ['$event'])
  // onMouseMove(event: MouseEvent) {
  //   clearTimeout(this.Timeout);
  //   this.Message_Close_Session();
  // }


  // public Message_Close_Session(): void {

  //   this.Timeout = setTimeout(() => {
  //     Swal.fire({
  //       position: "center",
  //       title: "La sesión se cerrará pronto",
  //       html: "parece que está inactivo, su sesión terminará en <b>300</b> segundos.",
  //       showConfirmButton: true,
  //       confirmButtonText: `Continuar con la sesión <i class="fa-solid fa-left-long fa-rotate-180"></i>`,
  //       confirmButtonColor: this.ColorConfirm,
  //       timer: 300000,
  //       timerProgressBar: true,
  //       didOpen: () => {
  //         const timer: any = Swal.getPopup()?.querySelector("b");
  //         setInterval(() => {
  //           let time: number = Swal.getTimerLeft() || 0
  //           timer.textContent = `${Math.round((time / 1000))}`;
  //         }, 1000);
  //       },
  //     }).then((result: any) => {
  //       if (result.isConfirmed) {
  //         clearTimeout(this.Timeout);
  //       } else {
  //         window.open('http://localhost:4202/_layouts/closeConnection.aspx?loginasanotheruser=true');
  //         localStorage.clear();
  //         this.router.navigate(['CloseSessionUse'])
  //       }
  //     });


  //   }, 900000);

  // }
}

